/**
 * API URL for backend requests
 * Uses environment variable if available, otherwise fallback to development URL
 */
export const API_URL = import.meta.env.VITE_API_URL || "/api/v1";

/**
 * Base API URL for Axios config and direct API calls
 */
export const API_BASE_URL = API_URL;

/**
 * Supported languages for the application
 */
export const SUPPORTED_LANGUAGES = ["en", "de", "fr", "it"];

/**
 * Pagination defaults
 */
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 12,
  OPTIONS: [6, 12, 24, 48],
};

/**
 * File upload limits
 */
export const UPLOAD_LIMITS = {
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_IMAGE_TYPES: ["image/jpeg", "image/png", "image/webp"],
};

/**
 * Order status types
 */
export const ORDER_STATUS = {
  PENDING: "pending",
  PROCESSING: "processing",
  SHIPPED: "shipped",
  DELIVERED: "delivered",
  CANCELLED: "cancelled",
};

/**
 * Payment methods
 */
export const PAYMENT_METHODS = {
  CREDIT_CARD: "credit_card",
  TWINT: "twint",
  STRIPE_BANK_TRANSFER: "stripe_bank_transfer",
  BANK_TRANSFER_MANUAL: "bank_transfer_manual",
};

/**
 * Shipping methods
 */
export const SHIPPING_METHODS = {
  STANDARD: "standard",
  EXPRESS: "express",
  OVERNIGHT: "overnight",
};

/**
 * User roles
 */
export const USER_ROLES = {
  ADMIN: "admin",
  BUYER: "buyer",
  GUEST: "guest",
};
